import styled from "@emotion/styled";
import type { ComponentProps, FC, PropsWithChildren, ReactNode } from "react";

import { MDSText, MDSTextColor, MDSTextVariant } from "@/mds";

type CardProps = PropsWithChildren<{
  className?: string;
}>;

type CardHeaderProps = {
  title: string;
  actions?: ReactNode;
  className?: string;
};

export const AudioRecordingCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.surface.pane};
`;

export const AudioRecordingCardHeader = ({ title, actions, className }: CardHeaderProps) => (
  <Header className={className}>
    <HeaderTitle variant={MDSTextVariant.TextSm}>{title}</HeaderTitle>
    {actions ? <HeaderActions>{actions}</HeaderActions> : null}
  </Header>
);

export const AudioRecordingCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AudioRecordingCardSection = ({ children, className }: CardProps) => (
  <Section className={className}>{children}</Section>
);

type CardLabelProps = PropsWithChildren<Partial<ComponentProps<typeof MDSText>>> & {
  className?: string;
};

const CardLabelText = styled(MDSText)`
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const AudioRecordingCardLabel: FC<CardLabelProps> = ({ children, ...rest }) => (
  <CardLabelText variant={MDSTextVariant.TextXs} color={MDSTextColor.Secondary} {...rest}>
    {children}
  </CardLabelText>
);

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const HeaderTitle = styled(MDSText)`
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
`;

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
